import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useImmer } from "use-immer";

const DashboardAlertCard = ({ content, createdDate }) => {

    // This Function for create content
    var initial_state = {
        finalDate: "",
        finalRuleName: "",
        EventDescription: "",
        DocTitle: ""
    };
    
    const [getContent, setContent] = useImmer(initial_state);
    
    
    function contentCreater(conten) {

        var finalDate = "";
        var finalRule = "";
        var finalDesc = "";
        var finalTitle = "";
    
        var Rul = conten.split("Rule Name:");
        if (Rul.length > 1) {
            var Rule2 = Rul[1].split("Event Description:");
                finalRule = Rule2[0].trim();
        }
    
        var Des = conten.split("Event Description:");

        if (Des.length > 1) {
            var Desc2 = Des[1].split("Document Title:");
                finalDesc = Desc2[0].trim();
        }
    
        var Titl = conten.split("Document Title:");
    
        if (Titl.length > 1) {
            var Title2 = Titl[1].split("Created Date:");
                finalTitle = Title2[0].trim();
        }
    
        var Dat = conten.split("Created Date:");
    
        if (Dat.length > 1) {
            var Date2 = Dat[1].split("Notification Frequency:");
                finalDate = Date2[0].trim();
        }
    
        setContent((draft) => {
            draft.finalDate = finalDate;
            draft.finalRuleName = finalRule;
            draft.EventDescription = finalDesc;
            draft.DocTitle = finalTitle;
        });
    };

    useEffect(() => {
        contentCreater(content);
    }, [content]);

    return (
        <Card className="dashboard-alert-card">

            <Card.Body className="dashboard-alert-body">

                <div className="dashboard-alert-header">

                    <div className="dashboard-alert-icon">
                        <i className="bi bi-bell-fill"></i>
                    </div>

                    <div className="dashboard-alert-title">

                        <h6>
                            {getContent.finalRuleName || "System Alert"}
                        </h6>

                        <span>
                            {getContent.finalDate || createdDate || "-"}
                            
                        </span>

                    </div>

                </div>

                <div className="dashboard-alert-content">

                    {getContent.EventDescription && (
                        <div className="dashboard-alert-detail">

                            <strong>
                                Description
                            </strong>

                            <span>
                                {getContent.EventDescription}
                            </span>

                        </div>
                    )}

                    {getContent.DocTitle && (
                        <div className="dashboard-alert-detail">

                            <strong>
                                Document Title
                            </strong>

                            <span>
                                {getContent.DocTitle}
                            </span>

                        </div>
                    )}
                </div>

            </Card.Body>

        </Card>
    );
};

export default DashboardAlertCard;